import React, { ChangeEventHandler, useEffect, useState } from "react";
import Styles from "./CallPopup.module.scss";

import QuickActionPopup, { QuickActionPopupProps } from "../quick-action-popup/QuickActionPopup";
import Input from "@vahak/core-ui/dist/components/Input";
import Flex, { VerticalFlex } from "@vahak/core-ui/dist/layout/Flex";
import Button from "@vahak/core-ui/dist/components/Button";
import { useSearchCompanyByPhoneNumberMutation } from "@vahak/core/dist/_services";
import { extractPhoneNumber, getJoinedStringFromArray } from "@vahak/core-ui/dist/methods";
import { CompanyDetailsV1Type } from "../../services/company/useGetCompanyDetailsV1";
import BordererCard from "@vahak/core-ui/dist/components/common/BordererCard/BordererCard";
import AppImg from "../utils/AppImg";
import Typography from "@vahak/core-ui/dist/components/Typography";
import { getImageNameFromURL } from "../../utils/getImageNameFromURL";
import { DotSymbol } from "@vahak/core-ui/dist/constants";
import { CallRequiredMeta } from "../../context/call/ClickToCallAppProvider";

interface AddToConferenceProps {
    onSubmit: (meta: CallRequiredMeta) => void;
    popupProps?: QuickActionPopupProps;
}

const AddToConference = ({ onSubmit, popupProps }: AddToConferenceProps) => {
    const getPhoneNumberDetails = useSearchCompanyByPhoneNumberMutation();

    const [phoneNumnber, setPhoneNumnber] = useState("");
    const [companyDetails, setCompanyDetails] = useState<CompanyDetailsV1Type>();
    const [canContinue, setCanContinue] = useState(false);

    const onChangePhoneInput: ChangeEventHandler<HTMLInputElement> = (e) => {
        const val = e?.target.value?.replace(/\D/g, "") ?? "";
        setPhoneNumnber(val);
        setCompanyDetails(undefined);
        setCanContinue(false);
    };

    useEffect(() => {
        const phoneNumber = extractPhoneNumber(phoneNumnber || "");
        if (phoneNumber?.length === 10) {
            getPhoneNumberDetails.mutate(
                { phoneNumber },
                {
                    onError: () => {},
                    onSuccess: (res) => {
                        if (res?.data?.length !== 0) {
                            const user: any = res?.data?.at(0);
                            setCompanyDetails(user);
                        }
                    },
                    onSettled: () => {
                        setCanContinue(true);
                    }
                }
            );
        }
    }, [phoneNumnber]);
    const { name = "", logo = "", service_type, location_text } = companyDetails || {};

    return (
        <div>
            <QuickActionPopup
                isOpen
                titleText="Add To Call"
                {...popupProps}
                description={
                    <VerticalFlex alignItems="center" gap={60}>
                        <div style={{ width: 500 }}>
                            <Input
                                headingLabel="Search Customer with phone number"
                                type="text"
                                value={phoneNumnber || ""}
                                onChange={onChangePhoneInput}
                                length={10}
                                prefixNode={"+91"}
                                inputMode="numeric"
                                outline="underline"
                            />
                        </div>
                        {!!companyDetails?.id && (
                            <BordererCard>
                                <Flex gap={20} justifyContent="space-between">
                                    <div className={Styles.person}>
                                        <AppImg
                                            src={getImageNameFromURL(logo || `default.png`)}
                                            alt={""}
                                            width={"60"}
                                            height={"60"}
                                            className={Styles.personImg}
                                        />
                                        <VerticalFlex>
                                            <Typography weight="semibold" size="sm">
                                                {name}
                                            </Typography>
                                            <Typography weight="semibold" size="sm">
                                                {getJoinedStringFromArray([service_type, location_text], DotSymbol)}
                                            </Typography>
                                        </VerticalFlex>
                                    </div>
                                </Flex>
                            </BordererCard>
                        )}

                        <Button
                            onClick={() =>
                                onSubmit({
                                    imgUrl: logo,
                                    name: name,
                                    number: phoneNumnber
                                })
                            }
                            width={500}
                            isRounded
                            disabled={!canContinue}
                        >
                            Merge Call
                        </Button>
                    </VerticalFlex>
                }
            />
        </div>
    );
};

export default AddToConference;
